import {removeServiceKfzState, updateServiceKfzState} from "../actions/service2kfzActions";
import isFunc from 'lodash/isFunction';
import {showSnackbar} from "../actions/snachbarActions";
import {isProcessing} from "../actions/processingActions";
import {PROC_KFZ_2_SERVICE} from "../actions";
import WorkTime from "../components/WorkTime";
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import {push} from "react-router-redux";
import {makeRoute, ROUTE_SERVICE_KFZ_ASSIGNMENT} from "../routes";

const m2s = (state) => {
	return {
		isSaving: (service_id, kfz_id) => isProcessing(state, PROC_KFZ_2_SERVICE, `${service_id}-${kfz_id}`)
	};
};
const m2d = (dispatch, props) => {
	return {
		onSave: props.onSave ? props.onSave : (data, onSuccess) => dispatch(updateServiceKfzState(data, result => {
			isFunc(onSuccess) && onSuccess(result);
			dispatch(showSnackbar('snackbar.service-kfz.updated'));
		})),
		onDelete: props.onDelete ? props.onDelete : (service, kfz, onSuccess) => dispatch(removeServiceKfzState(service, kfz, result => {
			isFunc(onSuccess) && onSuccess(result);
			dispatch(showSnackbar('snackbar.service-kfz.removed'));
		})),
		onShowDetail: props.onShowDetail !== undefined ? props.onShowDetail : (service_id, kfz_id) => dispatch(push(makeRoute(ROUTE_SERVICE_KFZ_ASSIGNMENT, {service_id, kfz_id})))
	};
};

const WorkTimeController = connect(m2s, m2d)(WorkTime);

WorkTimeController.propTypes = {
	title: PropTypes.string,
	open: PropTypes.bool,
	kfz2service: PropTypes.object,
	onShowDetail: PropTypes.func,
	onDelete: PropTypes.func,
	onSave: PropTypes.func,
	extendedData: PropTypes.object,
	onSaveSuccess: PropTypes.func,
	shouldClear: PropTypes.bool,
	priceRequired: PropTypes.bool,
	readOnlyTime: PropTypes.bool
};

export default WorkTimeController;


// WEBPACK FOOTER //
// ./src/containers/WorkTimeController.js